import colors from "../base/colors";

const { info, white, gradients, text, background } = colors;

const chip = {
    styleOverrides: {
        root: ({ ownerState }) => {
            // 👇 根据 color 动态映射
            const colorMap = {
                info: {
                    background: info.main,
                    color: white.main,
                },
                success: {
                    background: gradients.success.main,
                    color: white.main,
                },
                warning: {
                    background: gradients.warning.main,
                    color: white.main,
                },

                medium: {
                    background: gradients.medium.main,
                    color: white.main,
                },
                error: {
                    background: gradients.error.main,
                    color: white.main,
                },
                default: {
                    background: background.default,
                    color: text.main,
                },
            };

            const current = colorMap[ownerState.color] || colorMap.default;

            return {
                background: current.background,
                color: `${current.color} !important`,
            };
        },

        label: {
            color: "inherit !important",
        },
    },
};

export default chip;